import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  rotatingAnimation: FelaCSS;
  wrapper: FelaCSS;
}

const cssRotate = {
  '100%': { transform: 'rotate(360deg)' },
} as unknown as FelaCSS['animationName'];

const styles: IStyles = {
  rotatingAnimation: {
    animationDuration: '0.9s',
    animationIterationCount: 'infinite',
    animationName: cssRotate,
  },

  wrapper: {
    width: '100vw',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default styles;
